/**
 * One button per candidate. Pass the request's `candidateIds`, not the roster: core
 * rejects a submission naming anybody else.
 */

import type { ParticipantId } from '@gsf/contract';

export interface ParticipantGridProps {
  ids: readonly ParticipantId[];
  nameOf: (id: ParticipantId) => string | null;
  /** Already chosen — highlighted, and still tappable while the ask allows revision. */
  selectedIds?: readonly ParticipantId[];
  onPick: (id: ParticipantId) => void;
  disabled?: boolean;
  /** Shown instead of the buttons when there is nobody to offer. */
  emptyMessage?: string;
}

export function ParticipantGrid({
  ids,
  nameOf,
  selectedIds,
  onPick,
  disabled,
  emptyMessage = 'Nobody has joined yet.',
}: ParticipantGridProps) {
  if (ids.length === 0) {
    return <span className="faint">{emptyMessage}</span>;
  }

  const chosen = new Set(selectedIds ?? []);

  return (
    <div className="row participant-grid">
      {ids.map((id) => (
        <button
          key={id}
          type="button"
          className={`btn btn-sm${chosen.has(id) ? ' btn-primary' : ''}`}
          disabled={disabled}
          onClick={() => onPick(id)}
        >
          {nameOf(id) ?? 'Someone'}
        </button>
      ))}
    </div>
  );
}
